<div class="text-right"><span class="close" (click)="close()">
        <mat-icon>close</mat-icon>
    </span></div>
<div class="manual-wrapper">
    <ngx-extended-pdf-viewer [src]="docUrl" useBrowserLocale="true">
    </ngx-extended-pdf-viewer>
</div>